import { useHead } from '@unhead/vue'

function normalizeBase(base) {
  if (!base || base === '/') return '/'
  return base.startsWith('/') ? base : `/${base}`
}

function withLocale(base, locale) {
  if (base === '/') return `/${locale}`
  return `/${locale}${base}`
}

function getOrigin() {
  const env = (import.meta && import.meta.env && import.meta.env.VITE_FRONT_URL) || ''
  if (env) return env.replace(/\/$/, '')
  if (typeof window !== 'undefined') return window.location.origin
  return ''
}

export function buildHead({ base = '/', locale = 'ja', title, description, noindex = false }) {
  const origin = getOrigin()
  const norm = normalizeBase(base)
  const jaPath = withLocale(norm, 'ja')
  const enPath = withLocale(norm, 'en')
  const canonicalPath = locale === 'en' ? enPath : jaPath
  const canonical = `${origin}${canonicalPath}`
  const altJa = `${origin}${jaPath}`
  const altEn = `${origin}${enPath}`

  /** @type {import('@unhead/schema').Head } */
  const head = {
    title,
    meta: [
      ...(description ? [{ name: 'description', content: description }] : []),
      ...(noindex ? [{ name: 'robots', content: 'noindex,nofollow' }] : []),
    ],
    link: [
      { rel: 'canonical', href: canonical },
      { rel: 'alternate', hreflang: 'ja', href: altJa },
      { rel: 'alternate', hreflang: 'en', href: altEn },
      // default language for users with unspecified language
      { rel: 'alternate', hreflang: 'x-default', href: altJa },
    ],
  }
  return head
}

export function useSeoHead(opts) {
  return useHead(buildHead(opts))
}
